import React, { useCallback, useEffect, useState } from "react";
import { Typeahead } from 'react-bootstrap-typeahead';
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import s from './KeyItemBasic.module.css';
import { useNavigate } from "react-router-dom";
import {Button, Col, Form, Row, Image, Modal} from 'react-bootstrap';
import {RedButton, GreenButton, BlueButton} from './MyButton';
import {MyInput} from './Utilities/MyInput';
import addCirclePng from'../asset/add-circle.png';
import musicPlayer from'../asset/music-player.png';
import qtnMarkPng from'../asset/qtn-mark.png';
import MyComponentLoading from '../components/Utilities/MyComponentLoading';
import RelatedItems from '../components/RelatedItems';
import ItemTextType from '../components/ItemTextType';
import ShortReadingOverride from '../components/ShortReadingOverride';
import ItemSection from '../components/ItemSection';
import LuckyBagComponent from './LuckyBagComponent';
import ItemVideo from '../components/ItemVideo';
import {ItemConstant} from '../middleware/MyConstant';

const VocabCat = ({itemId, itemType, constTag}) => {
	const navigate = useNavigate();
	
	const [itemTag, setItemTag] = useState([]);
	
	const [show, setShow] = useState(false);
	const fetchData = async () => {		
		getData('item/keyTagByItemId?itemId=' + itemId, navigate)
		.then(res => {				
				let tmp = [];
				
				res.data.forEach((e)=>{
					if (e.tagType == 'category') {
						let stt = constTag.find((t) => t.id === e.tagId);
						tmp.push({id:e.tagId, name:stt.name});
					}
				})
				
				setItemTag(tmp);
			}
		);
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
  const handleClose = async () => {
		setShow(false);
		let obj = {
			itemId,
			tagType:null,
			tagIds:[]
		};
		
		obj.tagType = "category";
		obj.tagIds = itemTag.map(d=>(d.id))
		await postData("item/processKeyTheme", obj, navigate); 		
	};
	
	return (<div>	
		{(itemType != 84) && (
		<div>
			<Form.Group as={Col} sm={6} className="mb-3">
				<Row className="formTitle"  style={{width: "100%", paddingLeft: "0px"}}>
					<Form.Label as={Col}>Category</Form.Label>
					<Row style={{width: "100%", paddingLeft: "0px"}}>
						{ (itemTag != null && itemTag.length > 0) ? itemTag.map(ct => (
								<Col key={ct.id} sm={"auto"}>
									<span className="rectTag">{ct.name}</span>
								</Col>
							)
							): <Col sm={"auto"}><span>{"Nothing!"}</span></Col>
						}
						<Col sm={"auto"}>
							<span className="rectTag" style={{backgroundColor: "white", color:"#2EA44F"}}
								onClick={() => setShow(true)} >Edit</span>
						</Col>
					</Row>
				</Row>
			</Form.Group>		
		</div>)}
		
		<Modal show={show} onHide={handleClose}>
			<Modal.Header>
				<Modal.Title>Category</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Typeahead
					id="basic-typeahead-multiple"
					labelKey="name"
					multiple
					onChange={(d) => {
						setItemTag(d);
					}}
					options={constTag}
					placeholder="Choose category ..."
					selected={itemTag}
				/>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="primary" onClick={handleClose}>
					Save Changes
				</Button>
			</Modal.Footer>
		</Modal>
	</div>)
}


export default function KeyItemBasic(prop) {	
	const navigate = useNavigate();
	
	let itemId = prop.itemId;
	let itemType = prop.itemType;
	
	const [allKeyTagBasic, setAllKeyTagBasic] = useState(null);
	
	
	const [theme, setTheme] = useState([]);
	const [textType, setTextType] = useState([]);
	
	//const [readingType, setReadingType] = useState([]);
	//const [speakingTextType, setSpeakingTextType] = useState([]);
	const [listeningLabel, setListeningLabel] = useState([]);
	const [writingTheme, setWritingTheme] = useState([]);
	const [questionFormat, setQuestionFormat] = useState([]);
	const [questionType, setQuestionType] = useState([]);
	
	const [keyTag, setKeyTag] = useState([]);
	
	const [code, setCode] = useState("");
	const [startingQuestionNumber, setStartingQuestionNumber] = useState("1");
	const [timer, setTimer] = useState(0);
	const [displayMode, setDisplayMode] = useState("default");
	const [relationshipCode, setRelationshipCode] = useState("");
	const [topic, setTopic] = useState("");
	const [difficulty, setDifficulty] = useState("");
	const [isSerialStory, setIsSerialStory] = useState(false);
	const [subDifficulty, setSubDifficulty] = useState("");
	const [noteType, setNoteType] = useState("");
	const [teacherNote, setTeacherNote] = useState("");
	const [magicPenNote, setMagicPenNote] = useState("");
	const [length, setLength] = useState("");
	const [isVIP, setIsVIP] = useState(false);
	const [isBlur, setIsBlur] = useState(false);
	const [isHandwriting, setIsHandwriting] = useState(false);
	const [isHideName, setIsHideName] = useState(false);
	const [isFree, setIsFree] = useState(false);
	
	const [bindTarget, setBindTarget] = useState('student');
	const [bindClassInput, setBindClassInput] = useState('');
	
	const [subTheme, setSubTheme] = useState([]);
	const [subTextType, setSubTextType] = useState("");
	//const [subReadingType, setSubReadingType] = useState([]);
	//const [subSpeakingTextType, setSubSpeakingTextType] = useState([]);
	const [subListeningLabel, setSubListeningLabel] = useState([]);
	const [subWritingTheme, setSubWritingTheme] = useState([]);
	const [subQuestionFormat, setSubQuestionFormat] = useState([]);
	const [subQuestionType, setSubQuestionType] = useState([]);
	
	const [show, setShow] = useState(false);
	const [showType, setShowType] = useState("");
	
	
	const [ownerId, setOwnerId] = useState(null);
	const [ownerUsername, setOwnerUsername] = useState(null);
	const [courseName, setCourseName] = useState();
	const [price, setPrice] = useState();
	const [courseNameHk, setCourseNameHk] = useState();
	
	const getLabelByType = () => {
		switch(showType) {
			case 'subTheme': return "Theme";
			//case 'subReadingType': return "Reading Type";
			//case 'subSpeakingTextType': return "Speaking Type";
			case 'subListeningLabel': return "Listening Label";
			case 'subWritingTheme': return "Writing Theme";
			case 'subQuestionFormat': return "Label (type)";
			case 'subQuestionType': return "Label (Skill)";
		}
		return "";
	}
	
	const loadAsWks = async () => {
		let obj = { itemId };
		postData("questionApi/loadQuestionFormatAndTypeAsWks", obj, navigate); 
	}
	
  const handleClose = async () => {
		setShow(false);
		let obj = {
			itemId,
			tagType:null,
			tagIds:[]
		};
		switch(showType) {
			case 'subTheme':
				obj.tagType = "theme";
				obj.tagIds = subTheme.map(d=>(d.id))
				break;
			/*case 'subReadingType':
				obj.tagType = "reading_type";
				obj.tagIds = subReadingType.map(d=>(d.id))
				break;*/
			case 'subWritingTheme':
				obj.tagType = "writing_theme";
				obj.tagIds = subWritingTheme.map(d=>(d.id))
				break;
			/*case 'subSpeakingTextType':
				obj.tagType = "speaking_text_type";
				obj.tagIds = subSpeakingTextType.map(d=>(d.id))
				break;*/
			case 'subListeningLabel':
				obj.tagType = "listening_label";
				obj.tagIds = subListeningLabel.map(d=>(d.id))
				break;
			case 'subQuestionFormat':
				obj.tagType = "question_format";
				obj.tagIds = subQuestionFormat.map(d=>(d.id))
				break;
			case 'subQuestionType':
				obj.tagType = "question_type";
				obj.tagIds = subQuestionType.map(d=>(d.id))
				break;
		}
		
		await postData("item/processKeyTheme", obj, navigate); 
		
	};
		
	const updateDSEPaperType = async (dseType) => {
		setNoteType(dseType);
		
		let obj = {itemId, dseType}
		await postData("item/updateDSEPaperType", obj, navigate); 
	}		
		
	const updateNoteType = async (noteType) => {
		setNoteType(noteType);
		
		let obj = {itemId, noteType}
		
		await postData("item/updateNoteType", obj, navigate); 
	}		
		
	const updateTeacherNote = async () => {
		let obj = {itemId, teacherNote}
		
		await postData("item/updateTeacherNote", obj, navigate); 
	}		
		
		
	const updateMagicPenNote = async () => {
		let obj = {itemId, magicPenNote}
		
		await postData("item/updateMagicPenNote", obj, navigate); 
	}		
		
	const updateDifficulty = async (diff) => {
		setDifficulty(diff);
		
		let obj = {itemId, difficulty:diff}
		
		await postData("item/updateKeyDifficulty", obj, navigate); 
		
		//listening
		if (itemType == 74) {
			let tmpPrice = 7
			if (diff == 'Bridging') {
				tmpPrice = 5;
			} else if (diff == 'Pre-DSE-foundation') {
				tmpPrice = 6;
			} else if (diff == 'Pre-DSE-developing') {
				tmpPrice = 6;
			} else if (diff == 'Pre-DSE-essential') {
				tmpPrice = 7;
			} else if (diff == 'Pre-DSE-intermediate+') {
				tmpPrice = 7;
			}
			console.log(tmpPrice);
			await postData("item/updatePrice", {itemId, price:tmpPrice}, navigate); 
			setPrice(tmpPrice);
		}
		
	}		
	
	const updateIsHideName = async (isHideName) => {
		setIsHideName(isHideName);
		
		let obj = {itemId, isHideName}
		
		await postData("item/updateIsHideName", obj, navigate); 
	}		
	
	const updateIsBlur = async (isBlur) => {
		setIsBlur(isBlur);
		
		let obj = {itemId, isBlur}
		
		await postData("item/updateIsBlur", obj, navigate); 
	}		
	
	const updateIsHandwriting = async (isHandwriting) => {
		setIsHandwriting(isHandwriting);
		
		let obj = {itemId, isHandwriting}
		
		await postData("item/updateIsHandwriting", obj, navigate); 
	}		
	
	const updateTopic = async (topic) => {
		setTopic(topic);
		
		let obj = {itemId, topic}
		
		await postData("item/updateTopic", obj, navigate); 
	}	
	
	const updateIsSerialStory = async (isSerialStory) => {
		setIsSerialStory(isSerialStory);
		
		let obj = {itemId, isSerialStory}
		
		await postData("item/updateIsSerialStory", obj, navigate); 
	}		
	const updateIsVIP = async (isVIP) => {
		setIsVIP(isVIP);
		
		let obj = {itemId, isVIP}
		
		await postData("item/updateIsVIP", obj, navigate); 
	}		
	
	const updateIsFree = async (isFree) => {
		setIsFree(isFree);
		
		let obj = {itemId, isFree}
		
		await postData("item/updateIsFree", obj, navigate); 
	}		
	
	
	const updateLength = async (leng) => {
		setLength(leng);
		
		let obj = {itemId, Length:leng}
		
		await postData("item/updateKeyLength", obj, navigate); 
	}		
	
	
	const updatePrice = async () => {
		await postData("item/updatePrice", {itemId, price}, navigate); 
	}
	
	const updateCourseName = async () => {
		await postData("item/updateCourseName", {itemId, courseName}, navigate); 
	}
	
	const updateCourseNameHk = async () => {
		await postData("item/updateCourseNameHk", {itemId, courseNameHk}, navigate); 
	}
	
	const updateCode = async () => {
		let obj = {itemId, code}
		
		await postData("item/updateKeyCode", obj, navigate); 
	}		
	const updateRelationshipCode = async () => {
		let obj = {itemId, relationshipCode}
		
		await postData("item/updateKeyRelationshipCode", obj, navigate); 
	}		
	const updateDisplayMode = async (displayMode) => {
		setDisplayMode(displayMode);
		
		let obj = {itemId, displayMode}
		await postData("item/updateDisplayMode", obj, navigate); 
	}
	
	const updateStartingQuestionNumber = async () => {
		
		if (/^\d+$/.test(startingQuestionNumber)) {
			let obj = {itemId, startingQuestionNumber}
			await postData("item/updateStartingQuestionNumber", obj, navigate); 
		}
	}	
	
	const updateTimer = async () => {
		
		if (/^\d+$/.test(timer)) {
			let obj = {itemId, timer}
			await postData("item/updateTimer", obj, navigate); 
		}
	}		
	const updateTextType = async () => {
		let obj = {itemId, textType}
		
		await postData("item/updateKeyTextType", obj, navigate); 
	}		
		
		
	const handleShow = (t) => {
		setShowType(t);
		setShow(true)
	};
	
	const [fetchCompleted, setFetchCompleted] = useState(false);
	
	
	const fetchData = async () => {
		
		let tTheme = [];
		//let tReadingType = [];
		//let tSpeakingTextType = [];
		let tListeningLabel = [];
		let tWritingTheme = [];
		let tQuestionFormat = [];
		let tQuestionType = [];
		
		
		await getData('item/listKeyThemeBasic', navigate)
		.then(res => {
				setAllKeyTagBasic(res.data);
			
				setTheme(res.data.theme);
				//setReadingType(res.data.readingType);
				//setSpeakingTextType(res.data.speakingTextType);
				setListeningLabel(res.data.listeningLabel);
				setWritingTheme(res.data.writingTheme);
				setQuestionFormat(res.data.questionFormat);
				setQuestionType(res.data.questionType);
				tTheme = res.data.theme;
				//tReadingType = res.data.readingType;
				//tSpeakingTextType = res.data.speakingTextType;
				tListeningLabel = res.data.listeningLabel;
				tWritingTheme = res.data.writingTheme;
				tQuestionFormat = res.data.questionFormat;
				tQuestionType = res.data.questionType;
			}
		);
		
		await getData('item/keyItemByItemId?itemId=' + itemId, navigate)
		.then(res => {
				
				setOwnerId(res.data.ownerId);
				setOwnerUsername(res.data.ownerUsername);
				setCourseName(res.data.courseName);
				setPrice(res.data.price);
				setCourseNameHk(res.data.courseNameHk);
				setCode(res.data.code);
				setRelationshipCode(res.data.relationshipCode);
				setTopic(res.data.topic);
				setStartingQuestionNumber(res.data.startingQuestionNumber);
				setTimer(res.data.timer);
				setDisplayMode(res.data.displayMode);
				setTextType(res.data.textType);
				setDifficulty(res.data.difficulty);
				setSubDifficulty(res.data.subDifficulty);
				setNoteType(res.data.noteType);
				setTeacherNote(res.data.teacherNote);
				setMagicPenNote(res.data.magicPenNote);
				setLength(res.data.length);				
				setIsVIP((res.data.isVipItem) ? true : false);
				setIsBlur((res.data.isBlur) ? true : false);
				setIsHandwriting((res.data.isHandwriting) ? true : false);
				setIsSerialStory((res.data.isSerialStory) ? true : false);
				setIsHideName((res.data.isHideName) ? true : false);
				setIsFree((res.data.isFree) ? true : false);
			}
		);
		
		await getData('item/keyTagByItemId?itemId=' + itemId, navigate)
		.then(res => {
				setKeyTag(res.data);
				
				let sTheme = [];
				//let sReadingType = [];
				//let sSpeakingTextType = [];
				let sListeningLabel = [];
				let sWritingTheme = [];
				let sQuestionFormat = [];
				let sQuestionType = [];
				
				res.data.forEach((e)=>{
					switch (e.tagType) {
						case 'theme':
							let t = tTheme.find((t) => t.id === e.tagId);
							sTheme.push({id:e.tagId, displayName: t.displayName});
						
							//sTheme.push({id:e.tagId, name:tTheme.find((t) => t.id === e.tagId).name});
							break;
						/*case 'speaking_text_type':
							sSpeakingTextType.push({id:e.tagId, name:tSpeakingTextType.find((t) => t.id === e.tagId).displayName});	
							break;*/
						case 'writing_theme':
							let wt = tWritingTheme.find((t) => t.id === e.tagId);
							sWritingTheme.push({id:e.tagId, name:wt.name});
							break;
						case 'listening_label':
							let f = tListeningLabel.find((t) => t.id === e.tagId);
							sListeningLabel.push({id:e.tagId, displayName: f.displayName});
							break;
						case 'question_format':
							sQuestionFormat.push({id:e.tagId, name:tQuestionFormat.find((t) => t.id === e.tagId).name});							
							break;
						case 'question_type':
							sQuestionType.push({id:e.tagId, name:tQuestionType.find((t) => t.id === e.tagId).name});
							break;
					}
				})
				
				setSubTheme(sTheme);
				//setSubReadingType(sReadingType);
				//setSubSpeakingTextType(sSpeakingTextType);
				setSubWritingTheme(sWritingTheme);
				setSubListeningLabel(sListeningLabel);
				setSubQuestionFormat(sQuestionFormat);
				setSubQuestionType(sQuestionType);
				
				setFetchCompleted(true);
			}
		);
	
	
		await getData('item/listUsersByItemId?itemId=' + itemId, navigate)
		.then(res => {
				setAssignStudents(res.data);
		});
	
	
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	let noteTypeData = ["general","speaking", "writing", "grammar", "reading", "listening"];
	let displayModeData = ["default", "long-read"];

	
	
	const [assignStudents, setAssignStudents] = useState([]);
	const [bindStudentInput, setBindStudentInput] = useState("");
	const [bindStudentApiMessage, setBindStudentApiMessage] = useState("");
	
	const assignItemToStudent = async () => {
		if (bindTarget == 'student') {
			let obj = {}
			
			if (isNaN(bindStudentInput)) {
				obj = { itemId, itemType, username:bindStudentInput }
			} else {
				obj = { itemId, itemType, userId:bindStudentInput }
			}
			let res = await postData("item/assignItemToStudent", obj, navigate); 		
			if (res.responseMessage == "success") {
				setAssignStudents(res.data);
				setBindStudentInput("");
				setBindClassInput("");
			} else {
				setBindStudentApiMessage(res.responseMessage);
			}
		} else if (bindTarget == 'class') {
			let obj = {}
			
			obj = { itemId, itemType, classId:bindClassInput }
			
			let res = await postData("item/assignItemToClass", obj, navigate); 		
			if (res.responseMessage == "success") {
				setAssignStudents(res.data);
				setBindStudentInput("");
				setBindClassInput("");
			} else {
				setBindStudentApiMessage(res.responseMessage);
			}
		
		}
	}
	
	const removeAssignedStudent = async(userId) => {
		let obj =  { itemId, userId }
		let res = await postData("item/removeItemFromStudent", obj, navigate); 		
		setAssignStudents(res.data);
	}
	
	const bindOwner = async () => {
		let obj = {}
		
		if (isNaN(bindStudentInput)) {
			obj = { itemId, username:bindStudentInput }
		} else {
			obj = { itemId, userId:bindStudentInput }
		}
		let res = await postData("item/bindOwner", obj, navigate); 		
		if (res.responseMessage == "success") {
			setOwnerId(res.data.id);
			setOwnerUsername(res.data.username);
		} else {
			setBindStudentApiMessage(res.responseMessage);
		}
	}
	const deleteItem = async () => {
		let obj = {itemId}
		
		let res = await postData("item/deleteItem", obj, navigate);
	}
	
	useEffect(() => {
    if (bindStudentApiMessage) {
      const timeoutId = setTimeout(() => {
        setBindStudentApiMessage('');
      }, 10000);

      // Clean up the timeout when the component unmounts
      return () => clearTimeout(timeoutId);
    }
  }, [bindStudentApiMessage]);
	
	const removeOwner = () => {
		let	obj = { itemId }
		postData("item/bindOwner", obj, navigate);
		setOwnerId(null);
		setOwnerUsername(null);
	}
	
	if (!fetchCompleted) {
		return (<MyComponentLoading />)
	}
	
	return (<div style={{textAlign:"left", margin:"10px"}}>
	
		{
			//writing
			(itemType == 76) && (<div>
				<Form.Group as={Col} sm={6} className="mb-3">
					<Row className="formTitle"  style={{width: "100%", paddingLeft: "0px"}}>
						<Form.Label as={Col}>Writing Theme</Form.Label>
						<Row style={{width: "100%", paddingLeft: "0px"}}>
							{ (subWritingTheme != null && subWritingTheme.length > 0) ? subWritingTheme.map(ct => (
									<Col key={ct.id} sm={"auto"}>
										<span className="rectTag">{ct.name}</span>
									</Col>
								)
								): <Col sm={"auto"}><span>{"Nothing!"}</span></Col>
							}
							<Col sm={"auto"}>
								<span className="rectTag" style={{backgroundColor: "white", color:"#2EA44F"}}
									onClick={() => handleShow('subWritingTheme')} > Edit </span>
							</Col>
						</Row>
					</Row>
				</Form.Group>
			
			</div>)
		}
		
		<div className="formTitle" style={{width: "100%", justifyContent:"start", gap:"5px", marginBottom:"10px", padding:"10px", flexWrap:"wrap"}}>
			<div className={(isHideName==true) ? s.toggleButtonOtionChosen : s.toggleButtonOption}  onClick={()=>updateIsHideName(!isHideName)}>Hide Name</div>
			<div className={(isBlur==true) ? s.toggleButtonOtionChosen : s.toggleButtonOption}  onClick={()=>updateIsBlur(!isBlur)}>Blur</div>
			<div className={(isHandwriting==true) ? s.toggleButtonOtionChosen : s.toggleButtonOption}  onClick={()=>updateIsHandwriting(!isHandwriting)}>Handwriting</div>
			<div className={(isSerialStory==true) ? s.toggleButtonOtionChosen : s.toggleButtonOption}  onClick={()=>updateIsSerialStory(!isSerialStory)}>Serial Story</div>
			<div style={{color:"#917967"}}>|</div>
			<div style={{fontSize:"22px", color:"#202020"}}>Show</div>
			<div className={(isVIP==true) ? s.toggleButtonChosen : s.toggleButtonOption}  onClick={()=>updateIsVIP(true)}>VIP only</div>
			<div className={(isVIP==false) ? s.toggleButtonChosen : s.toggleButtonOption}  onClick={()=>updateIsVIP(false)}>ALL</div>	
			<div style={{color:"#917967"}}>|</div>
			<div style={{fontSize:"22px", color:"#202020"}}>Price</div>
			<div className={(isFree==true) ? s.toggleButtonChosen : s.toggleButtonOption}  onClick={()=>updateIsFree(true)}>Free</div>
			<div className={(isFree==false) ? s.toggleButtonChosen : s.toggleButtonOption}  onClick={()=>updateIsFree(false)}>Paid</div>
			<div style={{color:"#917967"}}>|</div>
						
			<MyInput inputLabel={"Coins required"} dataInput={price} changeAction={(e)=>{
				if (/^\d+$/.test(e)) {
					setPrice(e)
				}
			}} />	
			<GreenButton isEnabled={true} clickedAction={updatePrice} bText={"Update"} />
		</div>
		
		{
			(itemType == 73) && (<div style={{padding:"10px", marginBottom:"20px",border: "1px solid rgba(0, 0, 0, 0.1)", borderRadius: ".25rem"}}>	
				<ShortReadingOverride itemId={itemId} />
			</div>)

		}
		
		{(itemType == 84) && (<LuckyBagComponent itemId={itemId}/>)} 
		
		{(itemType != 84) && (
		<div className="formTitle" style={{width: "100%", marginBottom:"10px", flexDirection:"column", alignItems:"start", gap:"10px"}}>
			<div>
				<div style={{display:"flex", fontWeight:"bold", gap:"5px", alignItems:"center"}}>
						<div>Bind</div> 
						
						<GreenButton isEnabled={(true)} clickedAction={()=>{
							setBindTarget((bindTarget == 'student') ? 'class':'student')
						}} bText={bindTarget} />
						<div style={{fontSize:"12px"}}>* click to change bind target (student / class)</div> 
				</div>
			</div>
			
			<div>
				<div style={{display:"flex", alignItems: 'center'}}>
					<div style={{borderRadius:"5px", padding:"5px 10px 5px 0",background:"#94714f",color:"white", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
						{
							(bindTarget == 'student') && (<MyInput inputLabel={"Assign Student (Input ID or Name)"} dataInput={bindStudentInput} changeAction={setBindStudentInput} />)
						}
						{
							(bindTarget == 'class') && (<MyInput inputLabel={"Assign Class (Input ID only)"} dataInput={bindClassInput} changeAction={setBindClassInput} />)
						}
						<GreenButton isEnabled={
							((bindTarget == 'student') && bindStudentInput) ||
							((bindTarget == 'class') && bindClassInput)
							} clickedAction={()=>assignItemToStudent()} bText={"Bind"} />
					</div>
					<div style={{color:"red", marginLeft:"10px"}}>{bindStudentApiMessage}</div>
				</div>
				{
					assignStudents.map((as, indexAS) => (<div style={{display:"flex", margin:"2px 0 2px 0"}}>
						<div style={{borderRadius:"5px", padding:"5px 10px",background:"#6d9ca8",color:"white", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
							<div style={{background:"white", color:"black", borderRadius:"5px", padding:"4px 10px", marginRight:"4px"}}>ID: {as.userId}</div>
							<div style={{background:"white", color:"black", borderRadius:"5px", padding:"4px 10px", marginRight:"10px"}}>{as.username}</div>
							<RedButton isEnabled={true} clickedAction={()=>removeAssignedStudent(as.userId)} bText={"Remove"} />
						</div>
					</div>))
				}
				{
					(ownerId) && (<div style={{display:"flex"}}>
						<div style={{borderRadius:"5px", padding:"5px 10px",background:"#6d9ca8",color:"white", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
							<div style={{fontSize:"22px", paddingRight:"10px"}}>Current Student</div>
							<div style={{background:"white", color:"black", borderRadius:"5px", padding:"4px 10px", marginRight:"4px"}}>ID: {ownerId}</div>
							<div style={{background:"white", color:"black", borderRadius:"5px", padding:"4px 10px", marginRight:"10px"}}>{ownerUsername}</div>
							<RedButton isEnabled={true} clickedAction={()=>removeOwner()} bText={"Remove"} />
						</div>
					</div>)
				}
		
			</div>
		</div>)}
		
		
		{
			(ItemConstant.PaperIts.includes(itemType)) &&
				(<div style={{border:"1px solid #22222222", marginBottom:"20px"}}>				
					<div style={{display:"flex", margin:"15px 10px"}}>
						<div style={{margin:"0 10px 0 0", fontSize:"22px", whiteSpace:"nowrap"}}>Note Type</div>
				
						<div style={{marginRight:"5px"}} className={(noteType=='A') ? s.toggleButtonChosen : s.toggleButtonOption} 
							onClick={()=>updateDSEPaperType("A")}>A</div>
						<div style={{marginRight:"5px"}} className={(noteType=='B1') ? s.toggleButtonChosen : s.toggleButtonOption} 
							onClick={()=>updateDSEPaperType("B1")}>B1</div>
						<div style={{marginRight:"5px"}} className={(noteType=='B2') ? s.toggleButtonChosen : s.toggleButtonOption}  
							onClick={()=>updateDSEPaperType("B2")}>B2</div>
				
					</div>
				</div>)
		}
		
		{
			((ItemConstant.NoteTypeIts).includes(itemType)) &&
			(<div style={{border:"1px solid #22222222", marginBottom:"20px"}}>
				<div style={{margin:"15px 10px", display:"flex", alignItems:"center"}}>
					<div style={{margin:"0 10px 0 0", fontSize:"22px", whiteSpace:"nowrap"}}>Note Type</div>
					<div style={{display:"flex"}}>
						{
							noteTypeData.map((dd, indexDD) => (
								<div style={{marginRight:"5px"}} 
									className={(noteType==dd) ? s.toggleButtonChosen : s.toggleButtonOption}
									onClick={()=>updateNoteType(dd)}>{dd}</div>
							))
							
						}
			
					</div>
				</div>
			</div>)
		}
		
		
		
		{
			(ItemConstant.MagicPenNoteIts.includes(itemType)) &&
			(<div style={{border:"1px solid #22222222", marginBottom:"20px"}}>
				<div style={{margin:"10px", fontSize:"22px", whiteSpace:"nowrap"}}>
					<div style={{display:"flex"}}>
						<div style={{margin:"0 10px 0 0", fontSize:"22px", whiteSpace:"nowrap"}}>Magic-pen note</div>
						<GreenButton isEnabled={true} clickedAction={updateMagicPenNote} bText={"Update"} />
					</div>
					<div style={{display:"flex"}}>
						<textarea style={{border:"1px solid #22222222", width:"80%",
							overflow: 'auto',
							whiteSpace: 'pre-wrap',
							wordWrap: 'break-word'}} value={magicPenNote} className={s.textAreaAuto} 
							rows={5} wrap='off' onChange={(e) => {
							setMagicPenNote(e.target.value);
						}}/>
					</div>
				</div>
			</div>)
		}
		
		{
			(ItemConstant.TeacherOnlyNotesIts.includes(itemType)) &&
			(<div style={{border:"1px solid #22222222", marginBottom:"20px"}}>
				<div style={{margin:"10px", fontSize:"22px", whiteSpace:"nowrap"}}>
					<div style={{display:"flex"}}>
						<div style={{margin:"0 10px 0 0", fontSize:"22px", whiteSpace:"nowrap"}}>Teacher-only note</div>
						<GreenButton isEnabled={true} clickedAction={updateTeacherNote} bText={"Update"} />
					</div>
					<div style={{display:"flex"}}>
						<textarea style={{border:"1px solid #22222222", width:"80%",
							overflow: 'auto',
							whiteSpace: 'pre-wrap',
							wordWrap: 'break-word'}} value={teacherNote} className={s.textAreaAuto} 
							rows={5} wrap='off' onChange={(e) => {
							setTeacherNote(e.target.value);
						}}/>
					</div>
				</div>
			</div>)
		}
		
		{(itemType != 84) && (<div style={{border:"1px solid #22222222", marginBottom:"20px"}}>
			<div style={{display:"flex", margin:"10px 0"}}><div style={{width:"50%"}}>
					<MyInput inputLabel={"Course Name"} dataInput={courseName} changeAction={setCourseName} />
				</div>
				<div>
					<GreenButton isEnabled={true} clickedAction={updateCourseName} bText={"Update"} />
				</div>
			</div>
			<div style={{display:"flex", margin:"10px 0"}}><div style={{width:"50%"}}>
					<MyInput inputLabel={"Course Name HK"} dataInput={courseNameHk} changeAction={setCourseNameHk} />
				</div>
				<div>
					<GreenButton isEnabled={true} clickedAction={updateCourseNameHk} bText={"Update"} />
				</div>
			</div>
		
		<div style={{display:"flex", margin:"10px 0"}}><div style={{width:"50%"}}>
				<MyInput inputLabel={"Topic"} dataInput={topic} changeAction={setTopic} />
			</div>
			<div>
				<GreenButton isEnabled={true} clickedAction={()=>updateTopic(topic)} bText={"Update"} />
			</div>
		</div>
		
		{
			(ItemConstant.CodeIts.includes(itemType)) && (<div style={{display:"flex", margin:"10px 0"}}><div style={{width:"50%"}}>
					<MyInput inputLabel={"Code"} dataInput={code} changeAction={setCode} />
				</div>
				<div>
					<GreenButton isEnabled={true} clickedAction={()=>updateCode()} bText={"Update"} />
				</div>
			</div>)
		}
		{
			(ItemConstant.CodeIts.includes(itemType)) && (<div style={{display:"flex", margin:"10px 0"}}>
				<div style={{width:"50%"}}>
					<MyInput inputLabel={"Relationship Code"} dataInput={relationshipCode} changeAction={setRelationshipCode} />
				</div>
				<div>
					<GreenButton isEnabled={true} clickedAction={()=>updateRelationshipCode()} bText={"Update"} />
				</div>
			</div>)
		}
		{
			<div style={{display:"flex", margin:"10px 0"}}>
				<div style={{width:"50%"}}>
					<MyInput inputLabel={"Timer"} dataInput={timer} changeAction={setTimer} />
				</div>
				<div>
					<GreenButton isEnabled={true} clickedAction={()=>updateTimer()} bText={"Update"} />
				</div>
			</div>
		}
		{
			<div style={{display:"flex", margin:"10px 0"}}>
				<div style={{width:"50%"}}>
					<MyInput inputLabel={"Starting question number"} dataInput={startingQuestionNumber} changeAction={setStartingQuestionNumber} />
				</div>
				<div>
					<GreenButton isEnabled={true} clickedAction={()=>updateStartingQuestionNumber()} bText={"Update"} />
				</div>
			</div>
		}
			
		{
			(ItemConstant.TextType.includes(itemType)) && (<div style={{display:"flex", margin:"10px 0"}}>
				<div style={{width:"50%"}}>
					<MyInput inputLabel={"Text Type"} dataInput={textType} changeAction={setTextType} />
				</div>
				<div>
					<GreenButton isEnabled={true} clickedAction={()=>updateTextType()} bText={"Update"} />
				</div>
			</div>)
		}
		
		
		
		
		
		
		{
			
			(ItemConstant.DisplayModeIts.includes(itemType)) && (<div><div style={{width:"50%"}}>
				<div style={{margin:"15px 10px", display:"flex", alignItems:"center"}}>
					<div style={{margin:"0 10px 0 0", fontSize:"22px", whiteSpace:"nowrap"}}>Display Mode</div>
					<div style={{display:"flex"}}>
						{
							displayModeData.map((dd, indexDD) => (
								<div style={{marginRight:"5px"}} 
									className={(displayMode==dd) ? s.toggleButtonChosen : s.toggleButtonOption}
									onClick={()=>updateDisplayMode(dd)}>{dd}</div>
							))
							
						}

					</div>

				</div>
				</div>
			</div>)
		}
				

		{
			(<Difficulty itemId={itemId} itemType={itemType} difficulty={difficulty} setDifficulty={setDifficulty}/>)
		}
		
		{
			(<SubDifficulty itemId={itemId} itemType={itemType} subDifficulty={subDifficulty} setSubDifficulty={setSubDifficulty}/>)
		}
		
		
		
		
		</div>)}
		
		{
			<div style={{padding:"10px", marginBottom:"20px",border: "1px solid rgba(0, 0, 0, 0.1)", borderRadius: ".25rem"}}>	
				<ItemTextType itemId={itemId} itemType={itemType}/>
			</div>

		}
		
		
		
		{
			<div style={{padding:"10px", marginBottom:"20px",border: "1px solid rgba(0, 0, 0, 0.1)", borderRadius: ".25rem"}}>	
				<ItemSection itemId={itemId} itemType={itemType}/>
			</div>

		}
		{
			<div style={{padding:"10px", marginBottom:"20px",border: "1px solid rgba(0, 0, 0, 0.1)", borderRadius: ".25rem"}}>	
				<RelatedItems itemId={itemId} />
			</div>
		}
		
		{
			<ItemVideo itemId={itemId} />

		}
		
		{
			(!((ItemConstant.NonSubThemeIts).includes(itemType))) && (
		
				<Form.Group as={Col} sm={6} className="mb-3">
					<Row className="formTitle"  style={{width: "100%", paddingLeft: "0px"}}>
						<Form.Label as={Col}>Theme</Form.Label>
						<Row style={{width: "100%", paddingLeft: "0px"}}>
							{ (subTheme != null && subTheme.length > 0) ? subTheme.map(ct => (
									<Col key={ct.id} sm={"auto"}>
										<span className="rectTag">{ct.displayName}</span>
									</Col>
								)
								): <Col sm={"auto"}><span>{"Nothing!"}</span></Col>
							}
							<Col sm={"auto"}>
								<span className="rectTag" style={{backgroundColor: "white", color:"#2EA44F"}}
									onClick={() => handleShow('subTheme')} > Edit </span>
							</Col>
						</Row>
					</Row>
				</Form.Group>)
		}
		
		{(allKeyTagBasic) && (<VocabCat itemId={itemId} itemType={itemType} constTag={allKeyTagBasic.cat}/>)}
		{
			//listening
			(ItemConstant.ListeningLabelIts.includes(itemType)) && (<div>
				<Form.Group as={Col} sm={6} className="mb-3">
					<Row className="formTitle"  style={{width: "100%", paddingLeft: "0px"}}>
						<Form.Label as={Col}>Listening Label</Form.Label>
						<Row style={{width: "100%", paddingLeft: "0px"}}>
							{ (subListeningLabel != null && subListeningLabel.length > 0) ? subListeningLabel.map(ct => (
									<Col key={ct.id} sm={"auto"}>
										<span className="rectTag">{ct.displayName}</span>
									</Col>
								)
								): <Col sm={"auto"}><span>{"Nothing!"}</span></Col>
							}
							<Col sm={"auto"}>
								<span className="rectTag" style={{backgroundColor: "white", color:"#2EA44F"}}
									onClick={() => handleShow('subListeningLabel')} > Edit </span>
							</Col>
						</Row>
					</Row>
				</Form.Group>
			
			</div>)
		}
		
		{(itemType != 84) && 
			(ItemConstant.LabelSkillIts.includes(itemType)) && (<div>		
				<div style={{margin:"10px"}}>
					<BlueButton isEnabled={true} clickedAction={()=>loadAsWks()} bText={"Load Skills & Types as Qtn Wks"} />
				</div>
			
				<Form.Group as={Col} sm={6} className="mb-3">
					<Row className="formTitle"  style={{width: "100%", paddingLeft: "0px"}}>
						<Form.Label as={Col}>Label(skill)</Form.Label>
						<Row style={{width: "100%", paddingLeft: "0px"}}>
							{ (subQuestionType != null && subQuestionType.length > 0) ? subQuestionType.map(ct => (
									<Col key={ct.id} sm={"auto"}>
										<span className="rectTag">{ct.name}</span>
									</Col>
								)
								): <Col sm={"auto"}><span>{"Nothing!"}</span></Col>
							}
							<Col sm={"auto"}>
								<span className="rectTag" style={{backgroundColor: "white", color:"#2EA44F"}}
									onClick={() => handleShow('subQuestionType')} > Edit </span>
							</Col>
						</Row>
					</Row>
				</Form.Group>
			
				<Form.Group as={Col} sm={6} className="mb-3">
					<Row className="formTitle"  style={{width: "100%", paddingLeft: "0px"}}>
						<Form.Label as={Col}>Label(type)</Form.Label>
						<Row style={{width: "100%", paddingLeft: "0px"}}>
							{ (subQuestionFormat != null && subQuestionFormat.length > 0) ? subQuestionFormat.map(ct => (
									<Col key={ct.id} sm={"auto"}>
										<span className="rectTag">{ct.name}</span>
									</Col>
								)
								): <Col sm={"auto"}><span>{"Nothing!"}</span></Col>
							}
							<Col sm={"auto"}>
								<span className="rectTag" style={{backgroundColor: "white", color:"#2EA44F"}}
									onClick={() => handleShow('subQuestionFormat')} > Edit </span>
							</Col>
						</Row>
					</Row>
				</Form.Group>
			</div>)
		}
		
		<div>
			<RedButton isEnabled={true} clickedAction={deleteItem} bText={"Delete"} />
		</div>
		
		{/* ---------------------- modal ---------------------- */}
			<Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>{getLabelByType()}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
					{
						(showType === 'subTheme') && (<Typeahead
							id="basic-typeahead-multiple"
							labelKey="displayName"
							multiple
							onChange={(d) => {
								setSubTheme(d);
							}}
							options={theme}
							placeholder="Choose theme ..."
							selected={subTheme}
					/>)
					}
					{/*
						(showType === 'subSpeakingTextType') && (<Typeahead
							id="basic-typeahead-multiple"
							labelKey="displayName"
							multiple
							onChange={(d) => {
								setSubSpeakingTextType(d);
							}}
							options={speakingTextType}
							placeholder="Choose speaking text type ..."
							selected={subSpeakingTextType}
					/>)*/
					}
					{
						(showType === 'subWritingTheme') && (<Typeahead
							id="basic-typeahead-multiple"
							labelKey="name"
							multiple
							onChange={(d) => {
								setSubWritingTheme(d);
							}}
							options={writingTheme}
							placeholder="Choose writing theme ..."
							selected={subWritingTheme}
					/>)
					}
					{
						(showType === 'subListeningLabel') && (<Typeahead
							id="basic-typeahead-multiple"
							labelKey="displayName"
							multiple
							onChange={(d) => {
								setSubListeningLabel(d);
							}}
							options={listeningLabel}
							placeholder="Choose listening label ..."
							selected={subListeningLabel}
					/>)
					}
					{
						(showType === 'subQuestionFormat') && (<Typeahead
							id="basic-typeahead-multiple"
							labelKey="name"
							multiple
							onChange={(d) => {
								setSubQuestionFormat(d);
							}}
							options={questionFormat}
							placeholder="Choose question format ..."
							selected={subQuestionFormat}
					/>)
					}
					{
						(showType === 'subQuestionType') && (<Typeahead
							id="basic-typeahead-multiple"
							labelKey="name"
							multiple
							onChange={(d) => {
								setSubQuestionType(d);
							}}
							options={questionType}
							placeholder="Choose question type ..."
							selected={subQuestionType}
					/>)
					}
					
				</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
		
		
			{/* ---------------------- Top ---------------------- */}
		
		
		
		
		
		
		
		
	</div>);
	
}


const Difficulty = ({itemId, itemType, difficulty, setDifficulty}) => {
	const navigate = useNavigate();
	
	let difficultyData = [
		"IA (P5/P6)",
		"Pre-DSE Bridging",
		"Pre-DSE Foundation",
		"Pre-DSE Developing",
		"Pre-DSE Advanced",
		"Pre-DSE Elite-Elementary",
		"Pre-DSE Elite-Elementary+",
		"Pre-DSE Elite-Intermediate",
		"Pre-DSE Elite-Intermediate+",
		"Pre-DSE",
		"DSE Simplified",
		"DSE Essential",
		"DSE Intermediate+",
		"DSE Advanced",
		"IB-MYP-Y1-2", "IB-MYP-Y2-3", "IB-MYP-3",
	];

	/*
	let difficultyData = ["IB-MYP-Y1-2", "IB-MYP-Y2-3", "IB-MYP-3", "Bridging-Level-1", "Bridging-Level-2", "Bridging-Level-3", "Elite-Elementary","Elite-Intermediate","Elite-Intermediate+","Pre-DSE", "Pre-DSE-Advanced", "Essential", "Intermediate+", "Advanced", "Internal-Assessments"];
	
	if (itemType == 74) {
		difficultyData = ["IB-MYP-Y1-2", "IB-MYP-Y2-3", "IB-MYP-3", "Bridging", "Pre-DSE-foundation", "Pre-DSE-developing", "Pre-DSE-Advanced", "DSE-essential", "DSE-intermediate+", "Internal-Assessments"];
	}*/
	
	
	// Pre-DSE options are rendered as two rows (first 5 / remaining 5) to avoid an over-long single row.
	const preDseData = difficultyData.filter(i => !(["IB-MYP-Y1-2", "IB-MYP-Y2-3", "IB-MYP-3","DSE Simplified",
		"DSE Essential",
		"DSE Intermediate+",
		"DSE Advanced"].includes(i)));

	const updateDifficulty = async (sd) => {
		let obj = {itemId, difficulty:sd}
		if (sd == difficulty) {
			setDifficulty("");
			obj.difficulty = "";
		} else {
			setDifficulty(sd);
		}
		await postData("item/updateKeyDifficulty", obj, navigate); 
	}		
	
	
	return (<div>
		<div style={{margin:"10px", display:"flex", alignItems:"center", gap:"10px"}}>
			<div style={{fontSize:"22px", whiteSpace:"nowrap"}}>Pre DSE Difficulty</div>		
			{
				preDseData.slice(0, 5).map((sd, indexDD) => (
					<div
						className={(difficulty==sd) ? s.toggleButtonChosen : s.toggleButtonOption}
						onClick={()=>updateDifficulty(sd)}>{sd}</div>
				))
			}
		</div>
		<div style={{margin:"10px", display:"flex", alignItems:"center", gap:"10px"}}>
			<div style={{fontSize:"22px", whiteSpace:"nowrap", visibility:"hidden"}}>Pre DSE Difficulty</div>
			{
				preDseData.slice(5).map((sd, indexDD) => (
					<div
						className={(difficulty==sd) ? s.toggleButtonChosen : s.toggleButtonOption}
						onClick={()=>updateDifficulty(sd)}>{sd}</div>
				))
			}
		</div>
		<div style={{margin:"10px", display:"flex", alignItems:"center", gap:"10px"}}>
			<div style={{fontSize:"22px", whiteSpace:"nowrap"}}>DSE Difficulty</div>		
			{
				difficultyData.filter(i => (["DSE Simplified",
					"DSE Essential",
					"DSE Intermediate+",
					"DSE Advanced"].includes(i))).map((sd, indexDD) => (
					<div
						className={(difficulty==sd) ? s.toggleButtonChosen : s.toggleButtonOption}
						onClick={()=>updateDifficulty(sd)}>{sd}</div>
				))
			}
		</div>
		<div style={{margin:"10px", display:"flex", alignItems:"center", gap:"10px"}}>
			<div style={{fontSize:"22px", whiteSpace:"nowrap"}}>IB Difficulty</div>		
			{
				difficultyData.filter(i => ["IB-MYP-Y1-2", "IB-MYP-Y2-3", "IB-MYP-3"].includes(i)).map((sd, indexDD) => (
					<div
						className={(difficulty==sd) ? s.toggleButtonChosen : s.toggleButtonOption}
						onClick={()=>updateDifficulty(sd)}>{sd}</div>
				))
			}
		</div>
	</div>)
}

const SubDifficulty = ({itemId, itemType, subDifficulty, setSubDifficulty}) => {
	const navigate = useNavigate();
	
	let subDifficultyList = [];
	if (ItemConstant.grammarIts.includes(itemType)) {
		subDifficultyList = ['Elementary','Intermediate','Intermediate+','Advanced'];
	} else if (ItemConstant.readingIts.includes(itemType)) {
		subDifficultyList = ['Simple Questions','Moderate Questions','Full Mock'];
	}
	
	const updateSubDifficulty = async (sd) => {
		let obj = {itemId, subDifficulty:sd}
		if (sd == subDifficulty) {
			setSubDifficulty("");
			obj.subDifficulty = "";
		} else {
			setSubDifficulty(sd);
		}
		await postData("item/updateSubDifficulty", obj, navigate); 
	}		

	if (subDifficultyList.length == 0) {
		return (<></>)
	}
	
	return (<div>
		<div style={{margin:"10px", display:"flex", alignItems:"center", gap:"10px"}}>
			<div style={{fontSize:"22px", whiteSpace:"nowrap"}}>Sub-Difficulty</div>		
			{
				subDifficultyList.map((sd, indexDD) => (
					<div
						className={(subDifficulty==sd) ? s.toggleButtonChosen : s.toggleButtonOption}
						onClick={()=>updateSubDifficulty(sd)}>{sd}</div>
				))
				
			}
		</div>
	</div>)
}